import { BooleanInput } from '@angular/cdk/coercion';
import {
  Component,
  booleanAttribute,
  computed,
  contentChild,
  ElementRef,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CopyButton } from '../copy-button/copy-button.component';
import { EntityBadge } from '../entity-badge/entity-badge.component';

@Component({
  selector: 'procure-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  imports: [EntityBadge, CopyButton],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Menu {
  readonly title = input<string>();
  readonly isExpanded = input.required<boolean>();

  readonly suppressActive = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly dimActive = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly entityNumber = input<string | null>(null);

  readonly icons = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isLoading = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly bottom = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  protected readonly customTitle = contentChild<ElementRef>('title');
  protected get hasCustomTitle(): boolean {
    return !!this.customTitle();
  }

  protected readonly copyLink = computed(
    () => `${window.location.origin}/${this.entityNumber()}`,
  );
}
